// Opens the global contact form modal from anywhere (header CTA, contact CTA).
export function openContactForm() {
  window.dispatchEvent(new CustomEvent("tico:open-contact"));
}
